import * as THREE from 'three'
import { TUNING } from '../Game/definitions.js'

export default class Shadows
{
    constructor(_options)
    {
        this.container = new THREE.Group()
        this.renderer = _options.renderer
        this.renderer.shadowMap.enabled = true
        this.renderer.shadowMap.type = THREE.PCFSoftShadowMap

        this.light = new THREE.DirectionalLight(0xffffff, 1)
        this.light.position.set(-15, -15.9, 22.5)
        this.light.castShadow = true
        this.light.shadow.mapSize.set(2048, 2048)
        const shadowCameraRadius = TUNING.walkRadius + 6
        this.light.shadow.camera.left = - shadowCameraRadius
        this.light.shadow.camera.right = shadowCameraRadius
        this.light.shadow.camera.top = shadowCameraRadius
        this.light.shadow.camera.bottom = - shadowCameraRadius
        this.light.shadow.camera.near = 1
        this.light.shadow.camera.far = 80
        this.light.shadow.camera.updateProjectionMatrix()
        this.light.shadow.bias = -0.0002
        this.light.shadow.normalBias = 0.02
        this.container.add(this.light, this.light.target)

        const material = new THREE.ShadowMaterial({ color: 0x120d20, opacity: 0.55, depthWrite: false })
        this.catcher = new THREE.Mesh(new THREE.CircleGeometry(TUNING.walkRadius + 1.45, 64), material)
        this.catcher.position.z = 0.01
        this.catcher.receiveShadow = true
        this.container.add(this.catcher)
    }

    add(_reference)
    {
        _reference.traverse((_child) =>
        {
            if(_child.isMesh && !_child.material.transparent)
                _child.castShadow = true
        })
    }
}
